module.exports = __webpack_public_path__ + "static/media/store_information_block_option_3.3a01d87f.webp";